import { Form } from "radix-ui";
import "../css/form.css";
import toast, { Toaster } from "react-hot-toast";

const FormDemo = () => {
  const handleSubmit = (event) => {
    event.preventDefault();

 toast.success("✨ Message sent successfully! Adithya will get back to you soon.", {
  duration: 4500,
  position: "bottom-center",
  style: {
    background: "rgba(20, 20, 20, 0.85)",
    border: "1px solid rgba(255, 255, 255, 0.12)",
    borderRadius: "16px",
    color: "#f8fafc",
    fontSize: "18px",
    fontWeight: "500",
    padding: "18px 26px",
    boxShadow:
      "0 10px 40px rgba(0,0,0,0.6), inset 0 1px 1px rgba(255,255,255,0.05)",
    backdropFilter: "blur(12px)",
    WebkitBackdropFilter: "blur(12px)",
    letterSpacing: "0.3px",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    animation: "toastPop 0.55s cubic-bezier(0.25, 1, 0.5, 1)",
  },
  iconTheme: {
    primary: "#10b981",
    secondary: "white",
  },
  duration:4000,
});
	event.target.reset();
}
  return (
    <>
      <Form.Root className="FormRoot" onSubmit={handleSubmit}>
        <Form.Field className="FormField" name="email">
          <div
            style={{
              display: "flex",
              alignItems: "baseline",
              justifyContent: "space-between",
            }}
          >
            <Form.Label className="FormLabel">Email</Form.Label>
            <Form.Message className="FormMessage" match="valueMissing">
              Please enter your email
            </Form.Message>
            <Form.Message className="FormMessage" match="typeMismatch">
              Please provide a valid email
            </Form.Message>
          </div>
          <Form.Control asChild>
            <input className="Input" type="email" required />
          </Form.Control>
        </Form.Field>

        <Form.Field className="FormField" name="question">
          <div
            style={{
              display: "flex",
              alignItems: "baseline",
              justifyContent: "space-between",
            }}
          >
            <Form.Label className="FormLabel">Question</Form.Label>
            <Form.Message className="FormMessage" match="valueMissing">
              Please enter a question
            </Form.Message>
          </div>
          <Form.Control asChild>
            <textarea className="Textarea" required />
          </Form.Control>
        </Form.Field>

        <Form.Submit asChild>
          <button className="Button" style={{ marginTop: 10 }}>
            Post question
          </button>
        </Form.Submit>
      </Form.Root>

      <Toaster />
    </>
  );
};

export default FormDemo;
